export default __webpack_public_path__ + "static/media/logo.e5299ee8.svg";